module.exports = __webpack_public_path__ + "img/circle-blue-add.3907be97.svg";